var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scroll-top",on:{"click":_vm.scrollTop}},[_c('div',{staticClass:"scroll-top__button"},[_c('SvgIcon',{staticClass:"scroll-top__button-ico",attrs:{"name":"arrow-left2","width":"18","height":"16"}})],1),_c('div',{staticClass:"scroll-top__title"},[_vm._v("К началу страницы")])])
}
var staticRenderFns = []

export { render, staticRenderFns }